module.exports = __webpack_public_path__ + "media/images/ios_platform-82a564734b6ef43c35386e21ce27647f.png";